import React from 'react';
import { ZapIcon } from 'lucide-react';
import { CHECKOUT_URL } from '../data/content';
interface CtaButtonProps {
  label: string;
  subLabel?: string;
  href?: string;
  className?: string;
}
export function CtaButton({
  label,
  subLabel,
  href = CHECKOUT_URL,
  className = ''
}: CtaButtonProps) {
  const isInternal = href.startsWith('#');
  return <a href={href} target={isInternal ? undefined : '_blank'} rel={isInternal ? undefined : 'noopener noreferrer'} className={`inline-flex flex-col items-center justify-center rounded-md bg-orange-500 px-5 py-3.5 text-center text-slate-950 shadow-lg shadow-orange-500/40 ring-4 ring-orange-500/15 transition-[transform,background-color] duration-150 ease-out hover:-translate-y-0.5 hover:bg-orange-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-orange-500 active:translate-y-0 ${className}`} data-id="element-27" data-mp="cmvo7s9ucfxp">
      <span className="flex items-center justify-center gap-2 whitespace-nowrap text-[14px] font-black uppercase leading-tight tracking-wide sm:text-[15px]" data-id="element-28" data-mp="15b19qh8py8yl">
        <ZapIcon className="h-4 w-4 shrink-0 fill-slate-950" aria-hidden="true" data-id="element-29" data-mp="39y7y82d1fe7m" />
        {label}
      </span>
      {subLabel && <span className="mt-1 text-[0.65rem] font-bold uppercase tracking-[0.18em] text-slate-950/70" data-id="element-30" data-mp="3ex2mhjtrxuz4">
          {subLabel}
        </span>}
    </a>;
}